export default __webpack_public_path__ + "6bd099bfcae5e86c8189db1696d6aa54.svg";